export default __webpack_public_path__ + "static/media/dollar_coin_silver.35a92ccb.png";